import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { getSiteTopicDistribution } from "../../../api/statistics/site/SiteStatisticsAPI";
import RandomColor from "../../../util/RandomColor";
import { Chart as ChartJS, registerables } from "chart.js";
import { curveLineOptions } from "../../../util/ChartStyleUtil";
import { singleField } from "../../../util/ArrayUtil";
import { errorNoti } from "../../../util/SnackbarMessage";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
ChartJS.register(...registerables);
type SiteLineChartProps = {
  day: number;
  site: string;
};

function SiteLineChartPage(props: SiteLineChartProps) {
  const [siteTopicData, setSiteTopicData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(["error"]);
  var options = {
    plugins: {
      title: {
        display: false,
        text:
          "Số bài báo theo chủ đề (Tại " +
          props.site.toUpperCase() +
          " trong " +
          props.day +
          " ngày vừa qua)",
      },
    },
    responsive: true,
    elements: curveLineOptions().elements,
  };

  const dayLabels = [...new Set(singleField(siteTopicData, "time"))];

  const topicLabels = [...new Set(singleField(siteTopicData, "topic"))];

  function topicCount(topic: string) {
    return siteTopicData.filter((top) => {
      return top["topic"] === topic;
    });
  }

  let colors = new Map(
    topicLabels.map((topic) => [topic, RandomColor({ name: topic })])
  );

  const datasets = topicLabels.map(function (topicLabel) {
    const counts = topicCount(topicLabel).map((topic) => topic["count"]);
    return {
      label: topicLabel,
      data: counts,
      backgroundColor: colors.get(topicLabel),
      borderColor: colors.get(topicLabel),
    };
  });

  const data = {
    labels: dayLabels,
    datasets: datasets,
  };

  useEffect(() => {
    getSiteTopicDistribution(props.site, props.day)
      .then((res) => setSiteTopicData(res))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [props.day, props.site, colors.size]);
  return (
    <Line width={"100%"} height={"50%"} data={data} options={options}></Line>
  );
}

export default SiteLineChartPage;
